// @ts-ignore
import React from "react";
import {Stack, Typography} from "@mui/material";

const Loader = () => (
    <Stack width="100%" textAlign="center" justifyContent="center" alignItems="center">
        <img src="../../../public/logo512.png" className="App-logo" alt="logo"/>
        <Typography variant='h2' color='white'>Chargement...</Typography>
    </Stack>
);

export default Loader